import { render } from "./CrAuth.vue?vue&type=template&id=0d0b147b&scoped=true"
import script from "./CrAuth.vue?vue&type=script&lang=js"
export * from "./CrAuth.vue?vue&type=script&lang=js"

import "./CrAuth.vue?vue&type=style&index=0&id=0d0b147b&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0b147b"]])

export default __exports__